module.exports = __webpack_public_path__ + "static/img/bg-en.43609d01.png";